import type { TooltipProps } from "@mui/material";

import { Tooltip } from "@citrine/atoms/tooltip";

import * as sx from "./truncated-text.sx";

type TruncatedTextProps = Omit<
  React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLSpanElement>,
    HTMLSpanElement
  >,
  "title"
> & {
  // we have to further restrict children so it can be used as the tooltip title
  children: React.ReactNode;
  fullWidthTooltip?: boolean;
  placement?: TooltipProps["placement"];
  title?: React.ReactNode;
  tooltip?: boolean;
  tooltipClasses?: TooltipProps["classes"];
};

// returns a tooltip that has a matching title component and content component since we want them to be the same.
export function TruncatedText({
  children,
  fullWidthTooltip,
  // when we have longer elements that take up full width (like table columns) we do this to avoid having the tooltip from being off to the center with no content
  placement = "bottom-start",
  title = children,
  tooltip = true,
  tooltipClasses,
  ...props
}: TruncatedTextProps) {
  const content = <sx.Content {...props}>{children}</sx.Content>;

  return tooltip && title ? (
    <Tooltip
      classes={tooltipClasses}
      fullWidth={fullWidthTooltip}
      placement={placement}
      title={title ?? children}
      enterDelay={1000}
    >
      {content}
    </Tooltip>
  ) : (
    content
  );
}
